import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 批量启用 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 批量停用 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 同步 ")
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 开通 ")

import _ from "lodash";
import { reactive, getCurrentInstance, ref, onMounted } from "vue";
import StopUsing from "./transfer/stopUsing.vue";
import StaffInfoAndOpt from "./staffInfoAndOpt/index.vue";
import BatchImport from "./batchImport/index.vue";
import { IStaffForm, IStaffInfo, IStoreRole } from "./interface";


const __default__ = {
  name: "StaffConfigManagement",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  curUser: {
    type: Object,
  },
  terminal: {
    type: String,
    default: "",
  },
  createBtnPerm: {
    type: String || null,
  },
  importBtnPerm: {
    type: String || null,
  },
  editBtnPerm: {
    type: String || null,
  },
},
  setup(__props) {

const props = __props



const { proxy } = getCurrentInstance() as any;
const staffInfoAndOptRef = ref<any>(null);
const batchImportRef = ref<any>(null);
const state: any = reactive({
  form: {
    key: "",
  },
  paginationInfo: {
    total: 0,
    pageSize: 10,
    current: 1,
  },
  listData: [],
  storeRoleList: [],
  showTransferDialog: false,
  userMessage: {},
});

onMounted(() => {
  onSearch(1);
});

const onSearch = async (current: number) => {
  state.paginationInfo.current = current;
  state.storeRoleList = [];
  const requestObj = {
    ...state.form,
    ...state.paginationInfo,
  };
  if (state.form.tenantAndShop) {
    requestObj.currentTenantId = state.form.tenantAndShop[0];
    requestObj.currentShopId = state.form.tenantAndShop[1];
    delete requestObj.tenantAndShop;
  }
  const apis = {
    ops: "/ops/userTenant/page",
    mgr: "/mgr/userTenant/page",
  };
  let [res] = await proxy.$api.post(apis[props.terminal], requestObj);
  state.listData = res.content || [];
  state.paginationInfo.total = res.totalElements || 0;
  state.paginationInfo.current = res.number + 1;
  let arr: any[] = [];
  let obj: any = {};
  let userRole = proxy.pocket("userRole").length
    ? proxy.pocket("userRole")
    : res.extensionField.userRole;
  if (userRole) {
    userRole.forEach((x: any, i: number) => {
      if (arr.indexOf(x.value.shopId) !== -1) {
        state.storeRoleList.forEach((z: any) => {
          if (z.value === x.value.shopId) {
            z.children.push({
              label: x.value.name,
              value: x.value.id,
              disabled: x.value.disabled || x.value.shopDisabled,
            });
          }
        });
      } else {
        arr.push(x.value.shopId);
        obj = {
          label: x.value.shopName,
          value: x.value.shopId,
          children: [],
        };
        obj.children.push({
          label: x.value.name,
          value: x.value.id,
          disabled: x.value.disabled || x.value.shopDisabled,
        });
        state.storeRoleList.push(obj);
      }
    });
  }
};

const sizeChange = (size: number) => {
  state.paginationInfo.pageSize = size;
  onSearch(1);
};


const setStoreRole = (row: any) => {
  const item: IStoreRole[] = row.shopRoles;
  const storeRoleIdList = state.storeRoleList.map((item: any) => item.value);
  let str: any[] = [];
  if (item.length) {
    item.forEach((x: any) => {
      if (storeRoleIdList.includes(x.shopId)) {
        str.push(x.shopName + "/" + x.name);
      }
    });
  }
  return str.join(",");
};
const addStore = () => {
  const form: IStaffForm = {
    id: "",
    username: "",
    displayName: "",
    mobile: "",
    post: "",
    storeRoleList: [],
    wUserId: "",
    disabled: false,
    ...state.form,
    ...state.paginationInfo,
  };
  openModal("新建员工", "add", form);
};
const staffDeatil = (item: any) => {
  const form: IStaffForm = {
    id: item.id,
    username: item.username,
    displayName: item.displayName,
    mobile: item.mobile,
    post: item.post,
    storeRoleList: item.shopRoles,
    wUserId: item.wUserId,
    disabled: item.disabled,
    village: item.village,
    region: item.region,
    saleModel: item.saleModel,
    weChatMobile: item.weChatMobile,
    shop: item.shop,
    postType:item.postType,
    roleId:item.roleId
  };
  openModal("员工详情", "detail", form);
};
const staffEdit = (item: any) => {
  let itemCopy = _.cloneDeep(item);
  const form: IStaffForm = {
    id: itemCopy.id,
    username: itemCopy.username,
    displayName: itemCopy.displayName,
    mobile: itemCopy.mobile,
    post: itemCopy.post,
    postType: itemCopy.postType,
    saleModel: itemCopy.saleModel,
    region: itemCopy.region,
    village: itemCopy.village,
    shop: itemCopy.shop,
    weChatMobile: itemCopy.weChatMobile,
    version: itemCopy.version,
    storeRoleList: itemCopy.shopRoles,
    wUserId: itemCopy.wUserId,
    disabled: itemCopy.disabled,
    ...state.form,
    ...state.paginationInfo,
  };
  openModal("编辑员工", "edit", form);
};

const openStaff = async (item: any) => {
  const corpId = proxy?.$wecom.obtainDefaultImktCorp()?.corpId;

  let requestObj = {
    userId: item.id,
    disabled: item.disabled ? false : true,
    version: item.version,
    corpId: corpId,
    ...state.form,
    ...state.paginationInfo,
  };
  var api = "/mgr/userTenant/openStaff";
  const [res] = await proxy.$api.post(api, requestObj);
  proxy.$Message({
    type: "success",
    message: "操作成功",
  });
  state.listData = res.content || [];
  state.paginationInfo.total = res.totalElements || 0;
  state.paginationInfo.current = res.number + 1;
};

const openOrClose = async (item: any) => {
  const corpId = proxy?.$wecom.obtainDefaultImktCorp()?.corpId;

  let requestObj = {
    userId: item.id,
    disabled: item.disabled ? false : true,
    version: item.version,
    corpId: corpId,
    ...state.form,
    ...state.paginationInfo,
  };
  if (props.terminal === "ops") {
    var api = "/ops/userTenant/changeStatus";
  } else {
    var api = "/mgr/userTenant/changeStatus";
  }
  if (state.form.tenantAndShop) {
    requestObj.currentTenantId = state.form.tenantAndShop[0];
    requestObj.currentShopId = state.form.tenantAndShop[1];
    delete requestObj.tenantAndShop;
  }
  const [res] = await proxy.$api.post(api, requestObj);
  proxy.$Message({
    type: "success",
    message: "操作成功",
  });
  state.listData = res.content || [];
  state.paginationInfo.total = res.totalElements || 0;
  state.paginationInfo.current = res.number + 1;
};
const optionSuccess = (data: any) => {
  // 操作成功
  if (data) {
    state.listData = data.content || [];
    state.paginationInfo.total = data.totalElements || 0;
    state.paginationInfo.current = data.number + 1;
  } else {
    onSearch(1);
  }
};

const optionUploadExcelSuccess = () => {
  // 操作成功
  onSearch(1);
};

const openModal = (title: string, mode: string, form: any) => {
  // 启动弹层
  const info: IStaffInfo = {
    title,
    mode,
    storeList: state.storeRoleList,
    form,
    tenantAll: proxy.pocket("userRole"),
  };
  staffInfoAndOptRef.value.active(info);
};
const batchImport = () => {
  batchImportRef.value.active();
};

const syncWecomData = async (item: any) => {
  const corpId = proxy?.$wecom.obtainDefaultImktCorp()?.corpId;
  const suiteId = proxy?.$wecom.obtainImktSuite()?.suiteId;
  let syncWecomDataParam = {
    suiteId: suiteId,
    corpId: corpId,
  };
  if ((proxy?.$stores as any).store.state.CommonStore.terminal === "ops") {
    var api = "/ops/userTenant/syncWecomData";
  } else {
    var api = "/mgr/userTenant/syncWecomData";
  }
  const [res, data] = await proxy.$api.post(api, syncWecomDataParam, {
    timeout: 10*60*1000,
  });
  proxy?.$Message({
    type: "success",
    message: "同步数据成功",
  });
};

const confimForm = (res: any) => {
  state.form = { ...res };
  onSearch(state.paginationInfo.current);
};

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_mas_table = _resolveComponent("mas-table")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_mas_form_main, {
      form: _unref(state).form,
      defaultFormFooterConfirmText: "搜索",
      defaultFormFooterButton: ['confirm', 'reset'],
      onConfim: confimForm,
      inline: true,
      style: {"background-color":"#ffffff","padding-top":"20px","padding-left":"20px","margin-bottom":"10px"}
    }, {
      content: _withCtx((slotProps) => [
        (props.terminal === 'ops')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "租户门店"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: slotProps.content.tenantAndShop,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.tenantAndShop) = $event),
                  placeholder: "请选择租户门店",
                  props: { checkStrictly: true },
                  options: _ctx.pocket('TenantAll'),
                  filterable: "",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "搜索员工",
          prop: "key"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: slotProps.content.key,
              "onUpdate:modelValue": ($event: any) => ((slotProps.content.key) = $event),
              placeholder: "请输入员工手机号，姓名"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_component_mas_table, {
      ref: "masTableRef",
      pageConfig: _unref(state).paginationInfo,
      tableAttrs: {
        data: _unref(state).listData,
      },
      paginationListeners: {
        currentChange: onSearch,
        sizeChange: sizeChange,
      }
    }, {
      "tool-right": _withCtx(() => [
        (__props.curUser?.currentRole?.type == 'MANAGE' || __props.curUser?.currentRole?.type == 'ADMINISTRATORS')
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: addStore
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })), [
              [_directive_perm, __props.createBtnPerm]
            ])
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addStore
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })), [
          [_directive_perm, __props.createBtnPerm]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addStore
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })), [
          [_directive_perm, __props.createBtnPerm]
        ]),
        (__props.curUser?.currentRole?.visionLevel == 'TENANT')
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 1,
              class: "item",
              effect: "dark",
              content: "员工数据每日0 点同步更新，您也可以点击同步按钮手动同步员工数据",
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_el_button, {
                  type: "primary",
                  onClick: syncWecomData
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.$wecom?.obtainImktSuite()?.suiteId]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          "min-width": "55",
          fixed: "left"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "displayName",
          label: "姓名",
          "min-width": "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", {
              class: "pointer color-2d75d4",
              onClick: ($event: any) => (staffDeatil(scope.row))
            }, _toDisplayString(scope.row.displayName), 9, _hoisted_5)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "账号",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.username || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.mobile || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "weChatMobile",
          label: "企微号",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            (scope.row.weChatMobile == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(scope.row.mobile || "-"), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.weChatMobile || "-"), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "大区/小区/门店",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pocketLabel('saleModel',scope.row.saleModel)  || "-") + " / " + _toDisplayString(_ctx.pocketLabel('regions',scope.row.region)  || "-") + " / " + _toDisplayString(_ctx.pocketLabel('villages',scope.row.village)  || "-") + " / " + _toDisplayString(_ctx.pocketLabel('shopDepartments',scope.row.shop)  || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "post",
          label: "岗位/角色",
          "min-width": "100"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.post || "-") + " / " + _toDisplayString(_ctx.pocketLabel('userRole',scope.row?.shopRoles?.[0]?.roleId) || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.disabled ? "停用" : "启用"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          "min-width": "100"
        }, {
          default: _withCtx((scope) => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (staffEdit(scope.row)),
                disabled: scope.row.disabled
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"]),
              (scope.row.shopRoles?.[0]?.type == 'STAFF' && scope.row.state == 'NOT_OPENED')
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 0,
                    "icon-color": "red",
                    "popper-class": "hbb-work-fff",
                    onConfirm: ($event: any) => (openStaff(scope.row))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "text" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true),
              (__props.curUser?.currentRole?.type != 'STAFF' || scope.row.state != 'NOT_OPENED')
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 1,
                    "confirm-button-text": "是",
                    "cancel-button-text": "否",
                    "icon-color": "red",
                    "popper-class": "hbb-work-fff",
                    title: `此操作将${scope.row.disabled ? '启用' : '停用'}账号，是否继续?`,
                    onConfirm: ($event: any) => (openOrClose(scope.row))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "text" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.disabled ? "启用" : "停用"), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["title", "onConfirm"]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_perm, __props.editBtnPerm]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["pageConfig", "tableAttrs", "paginationListeners"]),
    _createVNode(StaffInfoAndOpt, {
      ref_key: "staffInfoAndOptRef",
      ref: staffInfoAndOptRef,
      onOptionSuccess: optionSuccess,
      terminal: props.terminal
    }, null, 8, ["terminal"]),
    _createVNode(BatchImport, {
      ref_key: "batchImportRef",
      ref: batchImportRef,
      onOptionUploadExcelSuccess: optionUploadExcelSuccess,
      terminal: props.terminal
    }, null, 8, ["terminal"]),
    _withDirectives(_createVNode(StopUsing, {
      user: _unref(state).userMessage,
      onClose: _ctx.closeTransferDialog
    }, null, 8, ["user", "onClose"]), [
      [_vShow, _unref(state).showTransferDialog]
    ])
  ]))
}
}

})